/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Lifecycle status of a PAM player. Mirrors the `pam_player_status` Postgres enum.
 * Additive in production — new values may be added without breaking existing code.
 * @export
 */
export const PamPlayerStatus = {
    _11184809: '11184809',
    active: 'active',
    probationary: 'probationary',
    deleted: 'deleted',
    self_excluded: 'self_excluded',
    suspended: 'suspended',
    unknown_default_open_api: '11184809'
} as const;
export type PamPlayerStatus = typeof PamPlayerStatus[keyof typeof PamPlayerStatus];


export function instanceOfPamPlayerStatus(value: any): boolean {
    for (const key in PamPlayerStatus) {
        if (Object.prototype.hasOwnProperty.call(PamPlayerStatus, key)) {
            if (PamPlayerStatus[key as keyof typeof PamPlayerStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PamPlayerStatusFromJSON(json: any): PamPlayerStatus {
    return PamPlayerStatusFromJSONTyped(json, false);
}

export function PamPlayerStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): PamPlayerStatus {
    return json as PamPlayerStatus;
}

export function PamPlayerStatusToJSON(value?: PamPlayerStatus | null): any {
    return value as any;
}

